__webpack_require__.p = "/manual-trader/";